import { useEffect } from 'react';
import Hero from './components/Hero';
import TopCasinos from './components/TopCasinos';
import NodepositBonuses from './components/NodepositBonuses';
import CashbackPrograms from './components/CashbackPrograms';
import PaymentMethods from './components/PaymentMethods';
import FaqCalculator from './components/FaqCalculator';
import NewsSection from './components/NewsSection';
import ReviewsSection from './components/ReviewsSection';
import ComparisonTable from './components/ComparisonTable';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.animate-on-scroll').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Hero />
      <TopCasinos />
      <NodepositBonuses />
      <CashbackPrograms />
      <ComparisonTable />
      <ReviewsSection />
      <PaymentMethods />
      <FaqCalculator />
      <NewsSection />
      <Footer />
    </div>
  );
}